import MuiForm from './MuiForm/MuiForm';

export { default as Form, generateForm } from './MuiForm';
export { default as Templates, generateTemplates } from './Templates';
export { default as Theme, generateTheme } from './Theme';
export { default as Widgets, generateWidgets } from './Widgets';

export default MuiForm;
